<!-- 政策库-->
<template>
  <div>
    <div class="idx_wrapper">
      <div class="row row1" id="hqzc">
        <div class="w_1200 box_wrap1">
          <img :src="require('@/assets/newStyle/images/idx_tit1.png')">
          <div class="r1_cont">
            <div class="r1_left">
              <a @click="check(11)" class="rc_row1"><img :src="require('@/assets/newStyle/images/r1_img1.png')"></a>
              <div class="rc_row2">
                <a @click="check(2)" class="fl"><img :src="require('@/assets/newStyle/images/r1_img2.png')"></a>
                <a @click="check(10)" class="fr"><img :src="require('@/assets/newStyle/images/r1_img3.png')"></a>
              </div>
            </div>
            <div class="r1_right" v-loading="vLoading" >

              <a v-for="(item, index) in zcrlList" :key="index" @click="openGgxq(item, 1)">
                <div class="tit_row slh">{{ item.name | ellipsisT }}</div>
                <div class="ms_row">
                  <span>发文字号：{{ item.fwzh }}</span>
                  <span>单位：{{ item.fbjg }}</span>
                  <span>发布时间：{{ item.publictime }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row row2" id="tscx">
        <img :src="require('@/assets/newStyle/images/idx_tit2.png')">
        <div class="w_1200 box_wrap1">

          <el-carousel :interval="5000" arrow="never" trigger="click">
            <el-carousel-item>
              <ul class="tscx_list" >
                <li>
             <!--     <a href="https://xy.hner.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/27jyzyggfwpt.png')" />
                    <span>教育资源公共服务平台</span>
                  </a>-->
                  <!-- <a href="http://www.xyzwfw.gov.cn/zwdt/xyzwdt/pages/xinyang_one_thing/xinyang.html" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/2xwqyhgtgshfw.png')" />
                    <span>小微企业和个体工商户服务</span>
                  </a> -->
                 <!-- <a href="https://ywdt.xygjj.cn:8888/netface/login.do" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/9gjjfwdt.png')" />
                    <span>公积金服务大厅</span>
                   </a>-->
                  <a href="https://ha.12348.gov.cn/#/home/home" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/10flfw.png')" />
                    <span>法律服务</span>
                  </a>
                  <a href="http://tzls.hazw.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/16tzxmsp.png')" />
                    <span>投资项目审批</span>
                  </a>
                </li>
                <!-- <li>
                  <a href="http://sme.xyppzx.com/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/3zxqyfw.png')" />
                    <span>中小企业服务</span>
                  </a>
                  <a href="http://suqiu.hngcc.org/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/4hnsqysqxypt.png')" />
                    <span>河南省企业诉求响应平台</span>
                  </a>
                </li> -->


                <li>
                   <a href="http://www.0376.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/29xyzx.png')" />
                    <span>信阳在线</span>
                  </a>
                  <a href="https://hn.bidcenter.com.cn/411500/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/38xyzbw.png')" />
                    <span>信阳招标网</span>
                  </a>
                </li>

                <li>


                  <a href="http://jrfw.hnzwfw.gov.cn/#/index" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/11hnjrfw.png')" />
                    <span>河南金融服务</span>
                  </a>
                  <a href="https://www.xyppzx.com/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/zxqyfw.png')" />
                    <span>信阳市中小企业服务平台</span>
                  </a>
                </li>
                <li>
                <!--  <a href="http://218.28.228.188/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/15bdcwsbsdt.png')" />
                    <span>不动产网上办事大厅</span>
                  </a>-->
                  <a href="https://www.xyggzyjy.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/8ggzyjypt.png')" />
                    <span>公共资源交易平台</span>
                  </a>
                  <a href="http://117.158.164.165:8811/open-data-web/index/index.do" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/1zfsjkfpt.png')" />
                    <span>政府数据开放平台</span>
                  </a>
                </li>
              </ul>
            </el-carousel-item>
            <el-carousel-item>
              <ul class="tscx_list">
                <li>
                  <a href="http://rsj.xinyang.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/18rlzyfw.png')" />
                    <span>人力资源服务</span>
                  </a>
                   <a href="http://www.gsxt.gov.cn/index.html" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/5qyxyxxgs.png')" />
                    <span>企业信用信息公示</span>
                  </a>
                </li>
                <li>
                  <a href="http://zxgk.court.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/7sxrymdcx.png')" />
                    <span>失信人员名单查询</span>
                  </a>
                  <a href="https://henan.chinatax.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/12nsfw.png')" />
                    <span>纳税服务</span>
                  </a>
                </li>
                <li>
                  <a href="http://jytyj.xinyang.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/13jytyfw.png')" />
                    <span>教育体育服务</span>
                  </a>
                  <a href="http://csglj.xinyang.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/14csglfw.png')" />
                    <span>城市管理服务</span>
                  </a>
                </li>
                <li>
                  <a href="http://www.hniss.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/36kyssyyqgxpt.png')" />
                    <span>科研设施与仪器共享平台</span>
                  </a>
                  <a href="http://xinyongxy.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/20xyfwpt.png')" />
                    <span>信用服务平台</span>
                  </a>
                <!--  <a href="http://www.hngp.gov.cn/xinyang" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/37xyzfcgw.png')" />
                    <span>信阳市政府采购网</span>
                  </a>-->
                </li>
<!--
                <li>


                </li>-->
              </ul>
            </el-carousel-item>
           <!-- <el-carousel-item>
              <ul class="tscx_list">
               &lt;!&ndash; <li>
                 &lt;!&ndash; <a href="http://www.xysti.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/35kjwxzygxpt.png')" />
                    <span>科技文献资源共享平台</span>
                  </a>&ndash;&gt;


                </li>
                <li>

                </li>&ndash;&gt;
               &lt;!&ndash; <li>
                  &lt;!&ndash; <a href="http://gxq.xinyang.gov.cn/" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/23xygxjscykfq.png')" />
                    <span>信阳高新技术产业开发区</span>
                  </a> &ndash;&gt;

                </li>&ndash;&gt;
                 &lt;!&ndash; <a href="https://scjgj.xinyang.gov.cn/index.php?m=content&c=index&a=lists&catid=70" target=“_blank”>
                    <img :src="require('@/assets/newIcon/images/17kbqyyct.png')" />
                    <span>开办企业一窗通</span>
                  </a> &ndash;&gt;
                <li>

                </li>
              </ul>
            </el-carousel-item>-->
          </el-carousel>

        </div>
      </div>
      <div class="row row3" id="swzq">
        <div class="w_1200 box_wrap1">
          <img :src="require('@/assets/newStyle/images/idx_tit3.png')">
          <div class="r3_cont" style="padding-top: 56px;">
            <a @click="tonewPage({title:'税惠直达'})" class="r3_right" style="float: left;width:260px;margin-right: 60px;">
              <img :src="require('@/assets/newStyle/images/swzq_img1.png')" style="width:100%;">
            </a>
            <div class="r3_left">

              <div class="rl_cont" style="min-height: 290px;" v-loading="vLoading2">
                <a @click="toPolicyDetail(item)" :title="item.name" v-for="(item, index) in swzqListData" :key="index" >
                  <span>{{ item.name}}</span>
                  <span>{{ item.publictime }}</span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row row3" id="xwqy" style="height: 554px;padding-top:0;">
        <div class="w_1200 box_wrap1" style="height: 476px;">
          <img :src="require('@/assets/newStyle/images/home2.png')">
          <div class="r3_cont" style="padding-top: 56px;">
            <div class="r3_left" style="width:100%;">
              <div class="r_tit" style="margin-top: 9px;">
                <span>小微企业和个体工商户服务专栏</span>
                <a @click="toPolicySearchGg">更多政策>></a>
              </div>
              <div class="rl_cont" style="min-height: 290px;" v-loading="vLoading2">
                <a @click="openGgxqNotice(item)" :title="item.name" v-for="(item, index) in noticeList" :key="index" >
                  <span>{{ item.name | ellipsisT }}</span>
                  <span>{{ item.policypubdate }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row3" id="qnrczj" style="height: 474px;">
        <div class="w_1200 box_wrap1">
          <img :src="require('@/assets/newStyle/images/home1.png')">
          <div class="r3_cont" style="padding-top: 56px;">
            <div class="r3_left" style="width:100%;">
              <div class="rl_row2">
                <a href="http://111.6.83.32:8086/web/#/jobList" target="_blank" class="bgImg1">就业求职</a>
                <a href="http://111.6.83.32:8086/web/#/index" target="_blank" class="bgImg2">人人持证</a>
                <a href="http://www.xyjyzp.com/" target="_blank" class="bgImg3">招聘服务</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row4" id="sjqk">
        <img :src="require('@/assets/newStyle/images/idx_tit4.png')">
        <div class="r4_cont">
          <div class="w_1200">
            <a @click="toPage('0')">
              <div class="num"><span>{{ policyNum }}</span>份</div>
              <div class="txt">惠企政策</div>
            </a>
            <a @click="toPage('1')">
              <div class="num"><span>{{ policyItemNum }}</span>项</div>
              <div class="txt">政策项目</div>
            </a>
            <a @click="toPage('2')">
              <div class="num"><span>{{ msjxNum }}</span>条</div>
              <div class="txt">免申即享</div>
            </a>
          <!--  <a>
              <div class="num"><span>{{ sqNum }}</span>个</div>
              <div class="txt">企业诉求</div>
            </a>-->
          </div>
        </div>
      </div>

    </div>
    <!--左侧浮动菜单-->
    <div class="fixed fixed_left" id="fMenu">
      <div class="f_tit"></div>
      <div class="f_menu">
        <a @click="check(11)" class="fmenu_icon1"></a>
        <a @click="check(2)" class="fmenu_icon2"></a>
        <a @click="check(10)" class="fmenu_icon3"></a>
        <a @click="position('hqzc')" class="fmenu_icon4" :class="{'active': activeIndex == 0}"></a>
        <a @click="position('tscx')" class="fmenu_icon5" :class="{'active': activeIndex == 1}"></a>
        <a @click="position('swzq')" class="fmenu_icon6" :class="{'active': activeIndex == 2}"></a>
        <a @click="position('xwqy')" class="fmenu_icon7" :class="{'active': activeIndex == 3}"></a>
        <a @click="position('qnrczj')" class="fmenu_icon8" :class="{'active': activeIndex == 4}"></a>
        <a @click="position('sjqk')" class="fmenu_icon9" :class="{'active': activeIndex == 5}"></a>
      </div>
      <div class="f_btm" @click="position('fixedMenuCont')"><span>TOP</span></div>
    </div>
    <!--右侧浮动菜单-->
    <div class="fixed fixed_right" style="display: none;">
      <a @click="tonewpage('政策咨询')">
        <img :src="require('@/assets/newStyle/images/r_zczx.png')">
        <span>政策咨询</span>
      </a>
      <a @click="tonewpage('企业诉求')">
        <img :src="require('@/assets/newStyle/images/r_qysq.png')">
        <span>企业诉求</span>
      </a>
      <a @click="tonewpage('定制服务')">
        <img :src="require('@/assets/newStyle/images/r_dzfw.png')">
        <span>定制服务</span>
      </a>
      <a @click="tonewpage('举报投诉')">
        <img :src="require('@/assets/newStyle/images/r_jbts.png')">
        <span>举报投诉</span>
      </a>
      <a @click="tonewpage('意见建议')">
        <img :src="require('@/assets/newStyle/images/r_yjjy.png')">
        <span>意见建议</span>
      </a>
    </div>
  </div>
</template>
<script type="text/javascript" src="src/assets/newStyle/js/jquery-3.1.1.min.js"></script>
<script type="text/javascript" src="src/assets/newStyle/js/jquery.bxslider.min.js"></script>
<script>

function fixedMenuScroll(contentObj,menuObj){
  menuObj.click(function () {
    var $idx = $(this).index();
    var contIdxTop = contentObj[$idx-3].offsetTop;
    $("body,html").animate({
      scrollTop:contIdxTop
    },500)
  });
  $(window).scroll(function() {
    contentObj.each(function (index) {
      var _target = parseInt($(this).offset().top - $(window).scrollTop()-50);
      if (_target <= 0) {
        menuObj.removeClass("active");
        menuObj.eq(index).addClass("active");
      }
      //如果到达页面底部，给左侧导航最后一个加active
      else if ($(document).height() == $(window).scrollTop() + $(window).height()) {
        menuObj.removeClass("active");
        menuObj.eq(menuObj.length - 1).addClass("active");
      }
    })
    /*if($(window).scrollTop()>=150){
      $("#fMenu").animate({
        top:'50%',
        marginTop:'-355px'
      },30)
    }else{
      $("#fMenu").animate({
        top:'458px',
        marginTop:'0'
      },10)
    }*/
  });
}
//左侧滚动菜单
fixedMenuScroll($('#fixedMenuCont>.row'),$("#fMenu>.f_menu>a:gt(0)"));

import { mapGetters } from "vuex";
export default {
  components: {
    // FilterGroup,
    // FilterCheckBoxTwo,
    // FilterCheckBoxThree,
  },
  data() {
    return {
      activeIndex: 0,
      typeIndex: 0, //控制标签选项显示
      noticeList: [],
      hydlList: [],
      cjList: [],
      swzqListData: [],
      showNum: 1,
      showSize: 4,
      showTotal: null,
      vLoading:true,
      vLoading2:true,
      // 搜索条件
      searchInfo: {
        data: {
          qylx: "", //企业类型
          xmlb: "", // 项目类别
          cylb: "", // 产业类别
          deptcode: "", // 发布部门
          zcfs: "", // 支持方式
          temp_amount: "", // 资金限额
          zzxeleft: "", // 起始资金限额
          zzxeright: "", // 结束资金限额
          name: "", // 事项名称
          hyle: "", //行业类别
          zcfl: "", //政策分类
          dq: "", //地区
        },
      },
      searchDataQylx: "", //搜索企业类型需要的数据
      searchDataZcfl: "", //搜索政策分类需要的数据
      searchDataDq: "", //搜索地区需要的数据
      searchDataDept: "", //搜索部门需要的数据
      searchDataQylxList: [], //搜索企业类型需要的数据
      searchDataZcflList: [], //搜索政策分类需要的数据
      searchDataDqList: [], //搜索地区需要的数据
      searchDataDeptList: [], //搜索部门需要的数据
      checkListQylx: [],
      checkListDq: [],
      checkListZcfl: [],
      checkListDept: [],
      sqNum: "0", //政策咨询诉求
      qyItemNum: "0", //企业项目数
      policyItemNum: "0", //政策项目数
      policyNum: "0", //政策数
      sceneNum: "0", //一件事一次办
      msjxNum:"0",
      zcrlList: [], //政策日历list
      fwzqList: [
        // {
        //   title: "税惠直达",
        //   imgUrl: require("@/assets/images/mccx.png"),
        // },
        {
          title: "就业求职",
          imgUrl: require("@/assets/images/pic2.png"),
        },
        {
          title: "人人持证",
          imgUrl: require("@/assets/images/pic3.png"),
        },
        {
          title: "招聘服务",
          imgUrl: require("@/assets/images/pic4.png"),
        },
      ], //服务专区
      zcflList: [], //政策分类
      hydlList2: [], //政策库页面移过来的部门数据
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.1, //数值越大速度滚动越快
        limitMoveNum: 5, //开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
    ...mapGetters({
      getDictList: "dictionary/getDictList",
    }),
    /**
     * @description: 已选择的搜索条件列表
     * @return {Array}
     */
    // cpu_noticeList() {
    //   return this.noticeList.slice(0, 4);
    // },
    cpu_paramsList() {
      let list = [];
      // 政策级别为多选
      if (this.searchDataDq) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataDq !== "") {
          arrData = this.searchDataDq.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.getDictList("policy_level").find(
              (cv) => cv.key === item
            )?.label;
            listlabel.push(label);
            this.searchDataDqList.push(label);
          });
          list.push({
            type: "zcfl",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      //主管部门
      if (this.searchDataDept) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataDept !== "") {
          arrData = this.searchDataDept.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.hydlList.find(
              (cv) => cv.deptCode === item
            )?.deptName;
            listlabel.push(label);
            this.searchDataDeptList.push(label);
          });
          list.push({
            type: "zgbm",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      // 去掉第一个逗号
      list.filter((item) => {
        if (item.label[0] == "，") {
          item.label = item.label.substring(1);
        }
      });
      return list;
    },
    cpu_paramsListW() {
      let list = [];
      // 企业类型
      if (this.searchDataQylx) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataQylx !== "") {
          arrData = this.searchDataQylx.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.getDictList("enterprise_size").find(
              (cv) => cv.key === item
            )?.label;
            listlabel.push(label);
            this.searchDataQylxList.push(label);
          });
          list.push({
            type: "qylx",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      // 去掉第一个逗号
      list.filter((item) => {
        if (item.label[0] == "，") {
          item.label = item.label.substring(1);
        }
      });
      return list;
    },
    cpu_paramsListT() {
      let list = [];
      // 政策分类
      if (this.searchDataZcfl) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataZcfl !== "") {
          arrData = this.searchDataZcfl.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.getDictList("sq_policy_xmlb").find(
              (cv) => cv.key === item
            )?.label;
            listlabel.push(label);
            this.searchDataZcflList.push(label);
          });
          list.push({
            type: "zcfl",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      // 去掉第一个逗号
      list.filter((item) => {
        if (item.label[0] == "，") {
          item.label = item.label.substring(1);
        }
      });
      return list;
    },
  },
  methods: {
    toPolicyDetail(policy) {
      window.sessionStorage.setItem("policyDetailData", JSON.stringify(policy));
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      let { href } = this.$router.resolve({
        name: "showPolicyDetail",
        query:{
          showSideNav:true,
        }
      });
      window.open(href, "_blank");
    },
    check(i) {
      let indexkey = i;
      switch (indexkey) {
        case 1:
          this.$router.push({
            name: "policyLibrary",
            // params: { titleType: this.titleType },
          });
          break;
        case 2:
          if (this.$store.getters.getUserInfo) {
            this.$router.push("/policyResult");
          } else {
            this.$router.push("/policy");
          }
          break;
        case 3:
          //判断是否登录
          if (this.$store.getters.getUserInfo) {
            this.$router.push({
              name: "policyMatchReport",
              // params: { titleType: this.titleType },
            });
          } else {
            //未登录
            this.toLogin("policyMatchReport");
          }

          break;
        case 4:
          this.$router.push({
            name: "policyProgram",
            // params: { titleType: this.titleType },
          });
          break;
        case 5:
          this.$router.push({
            name: "policyAnalysis",
            // params: { titleType: this.titleType },
          });
          break;
        case 6:
          this.$router.push({
            name: "qysq",
            // params: { titleType: this.titleType },
          });
          break;
        case 9:
          this.$router.push({
            name: "enterpriseLibrary",
            // params: { titleType: this.titleType },
          });
          break;
        case 10:
          this.$router.push({
            name: "showPolicy",
            // params: { titleType: this.titleType },
            query: { linkType: true },
          });
          break;
        case 11:
          this.$router.push({
            name: "viewEnjoyPage",
          });
          break;
        default:
          break;
      }
    },
    position(id){
      let el = document.getElementById(id);
      el.scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start',
        inline: 'start'
      })
    },
    toPage(index) {
      let ind = index,
        pathname = "";
      switch (ind) {
        case "0":
          this.$router.push({
            name: "showPolicy",
            query: { linkType: true },
          });
          break;
        case "1":
          pathname = "policyProgram";
          break;
        case "2":
          pathname = "viewEnjoyPage";
          break;
        case "3":
          pathname = "enterpriseLibrary";
          break;
        case "4":
          pathname = "qysq";
          break;
        default:
          break;
      }
      if(pathname){
        this.$router.push({name:pathname});
      }
    },
    tonewpage(sqProblemType) {
      if (this.$store.getters.getUserInfo) {
        sessionStorage.setItem("sqProblemType", sqProblemType);
        this.$router.push("/launchSuqiu");
      } else {
        this.toLogin();
      }
    },
    toLogin() {
      this.$router.push({ path: "/login2" });
    },
    getDeptList2() {
      let url = "/system/dept/zList";
      this.$httpApi
        .get(url, { priority: "1" })
        .then((res) => {
          // console.log('getDeptList:', res)
          if (res.data && !!res.data.length) {
            this.hydlList2 = res.data || [];
          }
          let temp = [];
          for (let i = 0; i < 3; i++) {
            temp.push(this.hydlList2[i]);
          }
          this.hydlList2 = temp;
        })
        .catch((err) => {
          console.log("getDeptList error:", res);
        });
    },
    checkTypeIndex(typeIndex) {
      if (this.typeIndex == typeIndex) {
        this.typeIndex = 0;
      } else {
        this.typeIndex = typeIndex;
      }
    },
    queryLabelDept() {
      let url = "/dev-api/enterprise-label/queryLabelDept";
      let params = {};
      this.$httpApi
        .post(url, params)
        .then((res) => {
          this.hydlList = res.data;
        })
        .catch((err) => {
          console.log("evaluate error:", err);
        });
    },
    toXmsb() {
      this.$router.push({
        name: "policyProgram",
        params: { titleType: this.titleType },
      });
      sessionStorage.setItem("titleType", 4);
    },
    // 按场景分类
    getCjList() {
      let url = "/onething/scene/list";
      this.$httpApi.get(url).then((r) => {
        this.cjList = r.rows;
      });
    },
    openCj(item) {
      this.$router.push({
        path: "/enterpriseLibrary",
        query: {
          item: item,
        },
      });
    },

    setParams() {
      this.searchDataDqList = [];
      this.searchDataDeptList = [];
      this.searchDataQylxList = [];
      this.searchDataZcflList = [];
      if (this.searchDataDq !== "") {
        this.searchDataDq.split(",").forEach((item) => {
          let label = this.getDictList("policy_level").find(
            (cv) => cv.key === item
          )?.label;
          this.searchDataDqList.push(label);
        });
      }
      if (this.searchDataDept !== "") {
        this.searchDataDept.split(",").forEach((item) => {
          let label = this.hydlList.find(
            (cv) => cv.deptCode === item
          )?.deptName;
          this.searchDataDeptList.push(label);
        });
      }
      if (this.searchDataQylx !== "") {
        this.searchDataQylx.split(",").forEach((item) => {
          let label = this.getDictList("enterprise_size").find(
            (cv) => cv.key === item
          )?.label;
          this.searchDataQylxList.push(label);
        });
      }
      if (this.searchDataZcfl !== "") {
        this.searchDataZcfl.split(",").forEach((item) => {
          let label = this.getDictList("sq_policy_xmlb").find(
            (cv) => cv.key === item
          )?.label;
          this.searchDataZcflList.push(label);
        });
      }
    },
    getSwzq(){  //  税务专区
      let url = `/sqzd/policy/policyInfoList?pageNum=1&pageSize=8`;
      // let url = '/elastic/search/sq-policy'
      let params = {
        deptId: "001003025002019",
        remark: '',
        name: '',
        orderBy: 1,
      };
      this.$httpApi.post(url, params).then((res) => {
        if (res.rows) {
          this.swzqListData = res.rows;
          console.log('this.swzqListData',this.swzqListData)
        }
      });
    },
    /**
     * 获取通知公告
     */
    getPublicList() {
      // let loadingnoticeRef = Loading.service({
      //   target: this.$refs.noticeRef,
      // });
      // type 1项目政策 2通知公告 3公开公示
      let params = {
        pageNum: 1,
        pageSize: 5,
        type: 2,
      };
      this.$httpApi
        .get(`/dev-api/document/list`, params)
        .then((res) => {
          if (res.code === 200) {
            // loadingnoticeRef.close();
            // this.noticeList = res.rows;
            let target = JSON.parse(JSON.stringify(res.rows));
            target.sort(function (a, b) {
              return a.policypubdate < b.policypubdate ? 1 : -1;
            });
            this.noticeList = target;
          }
          this.vLoading2 = false;
        })
        .catch((err) => {
          // loadingnoticeRef.close();
        });
    },
    /**
     * 获取列表数据
     */
    getPolicyLibraryCountNum() {
      this.$httpApi
        .get(`/dev-api/business/sq-apply/policyLibraryCountNum`, {})
        .then((res) => {
          this.sqNum = res.sqNum;
          this.qyItemNum = res.qyItemNum;
          this.policyItemNum = res.policyItemNum;
          this.policyNum = res.policyNum;
          this.sceneNum = res.sceneNum;
          this.msjxNum = res.msjxNum;
        })
        .catch((err) => {});
    },
    /**
     * 手动分页
     */
    checkList(type) {
      if (type == "last" && this.showNum > 1) {
        this.showNum--;
        this.getzcrlList(this.showNum, this.showSize);
      } else if (type == "next" && this.showNum < this.showTotal / 4) {
        this.showNum++;
        this.getzcrlList(this.showNum, this.showSize);
      } else {
        if (this.showNum == this.showTotal / 4) {
          this.$message.warning("当前页为最后一页");
        }
        if (this.showNum == 1) {
          this.$message.warning("当前页为第一页");
        }
      }
    },
    /**
     * @description 清空已选搜索项
     */
    cleanParamsW() {
      this.searchDataQylx = "";
      this.$refs.ws.cleanBoxList();
    },
    cleanParams() {
      this.searchDataZcfl = "";
      this.searchDataDq = "";
      this.searchDataDept = "";
      this.$refs.zcjb.cleanBoxList();
      this.$refs.zgbm.cleanBoxList();
      this.$refs.zcfl.cleanBoxList();
    },
    /**
     * 登录提示框点击确定登录，跳转登录页面
     */
    gotoLogin() {
      console.log("跳转登录页面");
      this.$router.push({
        path: "/login",
      });
    },
    /**
     * @description: 修改搜索条件
     */
    changeSearch(label, value, checkList) {
      // this.searchInfo.data.hyle;
      // 特殊情况不需要触发搜索
      //     资金限额自定义时
      switch (label) {
        case "主管部门":
          this.searchDataDept = value;
          this.checkListDept = checkList;
          break;
        case "政策分类":
          this.searchDataZcfl = value;
          this.checkListZcfl = checkList;
          break;
        case "政策级别":
          this.searchDataDq = value;
          this.checkListDq = checkList;
          break;
        default:
          //企业类型
          this.searchDataQylx = value;
          this.checkListQylx = checkList;
          break;
      }
    },
    toPolicySearchGg() {
      sessionStorage.setItem("menuIndex", "6");
      // sessionStorage.setItem(
      //   "titleTypeBack",
      //   sessionStorage.getItem("titleType")
      // );
      // sessionStorage.setItem("titleType", "10");
      this.$router.push({
        name: "searchList",
        params: {
          keyWords: "",
        },
      });
    },
    toPolicySearchGgDemo() {
      // this.$router.push({
      //   name: "gengduo",
      //   params: {
      //     keyWords: "",
      //   },
      // });
      let href = "http://111.6.83.32:8086/web/#/index";
      window.open(href,"_blank");
    },
    toPolicySearch() {
      this.setParams();
      sessionStorage.setItem("menuIndex", "2");
      let searchParams = {
        searchDataZcfl: this.searchDataZcflList,
        searchDataDq: this.searchDataDqList,
        searchDataDept: this.searchDataDeptList,
        searchDataQylx: this.searchDataQylxList,
        checkListQylx: this.checkListQylx,
        checkListDq: this.checkListDq,
        checkListZcfl: this.checkListZcfl,
        checkListDept: this.checkListDept,
        searchDataZcflT: this.searchDataZcfl,
        searchDataDqT: this.searchDataDq,
        searchDataDeptT: this.searchDataDept,
        searchDataQylxT: this.searchDataQylx,
      };
      this.$router.push({
        name: "searchList",
        params: {
          searchParams: searchParams,
        },
      });
    },
    toPolicySearchRadio2(item) {
      // 我要找部门问题查询
      console.log("item:", item);
      let searchDataDeptT = [];
      let checkListDept = item.deptId;
      searchDataDeptT.push(item.deptName);
      let searchDataZcfl = [];
      let checkListZcfl = [];
      let searchDataZcflT = "";
      let searchDataQylx = [];
      let checkListQylx = [];
      let searchDataQylxT = "";
      sessionStorage.setItem("menuIndex", "2");
      sessionStorage.setItem("titleType", "10");
      let searchParams = {
        searchDataDeptT,
        checkListDept,
        searchDataZcfl,
        checkListZcfl,
        searchDataZcflT,
        searchDataQylx,
        checkListQylx,
        searchDataQylxT,
      };
      this.$router.push({
        name: "searchList",
        params: {
          searchParams,
        },
      });
    },
    toPolicySearchRadio(item) {
      let resulutdata = item;
      let searchDataZcfl = [];
      let checkListZcfl = [];
      let searchDataZcflT = "";
      let searchDataQylx = [];
      let checkListQylx = [];
      let searchDataQylxT = "";
      sessionStorage.setItem("menuIndex", "2");
      // sessionStorage.setItem(
      //   "titleTypeBack",
      //   sessionStorage.getItem("titleType")
      // );
      sessionStorage.setItem("titleType", "10");
      let list = this.getDictList("enterprise_size");
      list.forEach((item, index) => {
        if (item.label == resulutdata.label) {
          checkListQylx.push(index);
          searchDataQylxT = resulutdata.key;
          searchDataQylx = resulutdata.label.split(",");
        }
      });
      this.zcflList.forEach((item, index) => {
        if (item.label == resulutdata.label) {
          checkListZcfl.push(index);
          searchDataZcflT = resulutdata.key + "";
          searchDataZcfl = resulutdata.label.split(",");
        }
      });
      let searchParams = {
        searchDataZcfl,
        checkListZcfl,
        searchDataZcflT,
        searchDataQylx,
        checkListQylx,
        searchDataQylxT,
      };
      this.$router.push({
        name: "searchList",
        params: {
          searchParams,
        },
      });
    },

    /**
     * 惠企政策点击
     */
    openGgxq(val, type) {
      let that = this;
      // let { href } = that.$router.resolve({
      //   path: "/notice/detail/" + val.id + "?detailType=" + type,
      // });
      this.$router.push({
        path: "/notice/detail/" + val.id + "?detailType=" + type,
      });
      // window.open(href, "_blank");
    },

    openGgxqNotice(item) {
      let eid = item.id;
      let etype = item.type;

      /*      let that = this;
      let { href } = that.$router.resolve({
        path: "/notice/detail/" + eid + "?detailType=" + etype,
      });
      window.open(href, "_blank");*/

      this.$router.push({
        path: "/notice/detail/" + eid + "?detailType=" + etype,
      });
    },
    getzcrlList(pageNum, pageSize) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "加载中，请稍后",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      //   customClass: "loadingin",
      // });
      let url = "/dev-api/business/sq-apply/squeryNewPerm";
      let params = {
        pageSize: pageSize,
        pageNum: pageNum,
        isChoose: false,
      };
      this.$httpApi
        .post(url, params)
        .then((r) => {
          this.zcrlList = r.list;
          console.log('this.zcrlList',this.zcrlList)
          this.vLoading = false;
          this.zcrlList.forEach((element) => {
            element.content = element.content
              .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
              .replace(/<[^>]+?>/g, "")
              .replace(/\s+/g, " ")
              .replace(/ /g, " ")
              .replace(/>/g, " ")
              .replace(/&nbsp;/g, " ");
            if (element.content.length > 10) {
              element.content = element.content.slice(0, 40) + "...";
            }
          });
          this.showTotal = r.total;
        })
        .catch((e) => {});
    },
    // openTest(){
    //   this.$message.warning("正在建设中！！！");
    // },
    tonewPage(item) {
      switch (item.title) {
        case "就业求职":
          // this.$router.push("jiuyeqiuzhi");
          window.open("http://111.6.83.32:8086/web/#/jobList","_blank");
          break;
        case "人人持证":
          // this.$router.push("zhiyexuexiao");
          window.open("http://111.6.83.32:8086/web/#/index","_blank");
          break;
        case "招聘服务":
          // this.$router.push("zhaopinxinxi");
          window.open("http://111.6.83.32:8086/web/#/index","_blank");
          break;
        case "税惠直达":
          //this.$message.warning("正在建设中！！！");
          this.$router.push("policyService");
          break;
        case "企乐无穷":
          window.open("http://qlwq.lhiit.gov.cn/", "_blank");
          break;
        case "金融服务":
          window.open("http://www.lhjrfw.com/", "_blank");
          break;
        case "政务服务":
          window.open(
            "http://www.lhzwfw.gov.cn/zwdt/epointzwmhwz/pages/legal/wanttodo",
            "_blank"
          );
          break;
        default:
          break;
      }
    },
    hszdPage() {
      this.$router.push("policyService");
    },
    getzcflList() {
      let url = "/dev-api/system/dict/getZcDictListByType";
      let params = {};
      this.$httpApi
        .get(url, params)
        .then((r) => {
          this.zcflList = r.data.slice(0, 6);
        })
        .catch((e) => {});
    },
    topolicyService() {
      this.$router.push({ path: "showPolicy", query: { linkType: true } });
      sessionStorage.setItem("titleType", 10);
    },
    getProjectLibrary() {
      let url = "/elastic/search/sq-policy";
      let params = {
        pageNum: 1,
        pageSize: 1,
        keyWords: "",
        areaValue: [],
        enterpriseAttributesValue: [],
        enterpriseSizeValue: [],
        growthCycleValue: [],
        sysCategoryValue: [],
        policyClassificationValue: [],
        deptName: [],
      };
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          this.policyNum = res.total;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onScroll(){
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.idx_wrapper .row')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop);
      })
      // 获取当前文档流的 scrollTop
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      this.activeIndex = navIndex;
    }
  },

  created() {
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sq_policy_xmlb",
        "sys_category", // 行业类别(国民经济分类)
        "enterprise_size",
        "policy_level", //政策层级
      ],
    });
    this.getSwzq()
    this.getPublicList();
    this.getPolicyLibraryCountNum();
    //this.getProjectLibrary();
    this.queryLabelDept();
    this.getCjList();
    this.getzcrlList(1, 4);
    this.getzcflList();
  //  this.getDeptList2();
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
    ellipsisT(value) {
      // if (!value) return "";
      if (value && value.length > 30) {
        return value.slice(0, 30) + "...";
      } else {
        return value;
      }
    },
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";
@import "@/assets/newStyle/css/login.scss";

.bgImg1{
  background-image: url("~@/assets/newStyle/images/swzq_img2.png");
}
.bgImg2{
  background-image: url("~@/assets/newStyle/images/swzq_img3.png");
}
.bgImg3{
  background-image: url("~@/assets/newStyle/images/swzq_img4.png");
}
.idx_wrapper .row3 .r3_left .rl_row2 a{
  width: 370px;
  height: 155px;
  background-size: 100%;
  font-size: 30px;
}
::v-deep{
  .el-carousel__indicator.is-active button {
    background: #1472FF;
    height: 6px;
    border-radius: 6px;
  }

  .el-carousel__button {
    background: rgba(20,114,255,0.5);
    height: 6px;
    border-radius: 6px;
  }
}

</style>
